import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PathwaySelector = ({ onSelectPathway }) => {
  const pathways = [
    {
      id: 'quick',
      title: 'Quick Start',
      description: 'Get matched immediately with minimal questions (2-3 minutes)',
      icon: 'Zap',
      features: [
        'Immediate matching available',
        'Essential questions only',
        'Skip detailed preferences',
        'Ideal for urgent support needs'
      ],
      buttonText: 'Start Quick Match',
      variant: 'default'
    },
    {
      id: 'comprehensive',
      title: 'Comprehensive Questionnaire',
      description: 'Detailed preference capture for optimal matching (8-10 minutes)',
      icon: 'ClipboardList',
      features: [
        'Personalized helper matching',
        'Cultural & language preferences',
        'Detailed symptom assessment',
        'Better long-term outcomes'
      ],
      buttonText: 'Complete Full Assessment',
      variant: 'outline'
    }
  ];

  return (
    <div className="w-full max-w-5xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          Choose Your Path
        </h2>
        <p className="text-muted-foreground">
          Select how you'd like to proceed with finding support
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {pathways?.map((pathway) => (
          <div 
            key={pathway?.id}
            className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow duration-200"
          >
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={pathway?.icon} size={24} className="text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-1">
                  {pathway?.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {pathway?.description}
                </p>
              </div>
            </div>

            <ul className="space-y-2 mb-6">
              {pathway?.features?.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-sm">
                  <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                  <span className="text-foreground">{feature}</span>
                </li>
              ))}
            </ul>

            <Button
              variant={pathway?.variant}
              fullWidth
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => onSelectPathway(pathway?.id)}
            >
              {pathway?.buttonText}
            </Button>
          </div>
        ))}
      </div>
      <div className="mt-8 p-4 bg-muted/50 rounded-lg border border-border">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-primary mt-0.5 flex-shrink-0" />
          <div className="text-sm">
            <p className="text-foreground font-medium mb-1">Your Privacy Matters</p>
            <p className="text-muted-foreground">
              All information is encrypted and stored securely. You control what you share and can update preferences anytime. Required fields are marked for safety protocols only.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PathwaySelector;